import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useTheme } from '../context/ThemeContext';

const { FiMenu, FiX, FiArrowRight, FiSun, FiMoon } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDark, toggleTheme } = useTheme();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 dark:bg-dark-bg/95 backdrop-blur-sm border-b border-arch-border dark:border-dark-border transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvcG5n/6e794689a22df1922a5088f411fb4372.png" 
                alt="WALL | WELL Logo" 
                className="h-8 md:h-10 w-auto dark:invert" 
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/features" className="text-xs font-bold text-arch-gray dark:text-gray-400 hover:text-accent-teal dark:hover:text-accent-teal transition-colors uppercase tracking-widest">
              Vlastnosti
            </Link>
            <Link to="/products" className="text-xs font-bold text-arch-gray dark:text-gray-400 hover:text-accent-sage dark:hover:text-accent-sage transition-colors uppercase tracking-widest">
              Produkty
            </Link>
            <Link to="/materials" className="text-xs font-bold text-arch-gray dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-500 transition-colors uppercase tracking-widest">
              Materiály
            </Link>
            <Link to="/specifications" className="text-xs font-bold text-arch-gray dark:text-gray-400 hover:text-accent-clay dark:hover:text-accent-clay transition-colors uppercase tracking-widest">
              Specifikace
            </Link>
            <Link to="/downloads" className="text-xs font-bold text-arch-gray dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-500 transition-colors uppercase tracking-widest">
              Stažení
            </Link>
            
            <div className="flex items-center space-x-6 pl-4 border-l border-arch-border dark:border-dark-border">
              {/* Theme Toggle */}
              <button 
                onClick={toggleTheme}
                className="text-arch-gray dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-500 transition-colors"
                aria-label="Toggle Dark Mode"
              >
                <SafeIcon icon={isDark ? FiSun : FiMoon} className="w-5 h-5" />
              </button>
              
              <a href="/#contact" className="group flex items-center space-x-2 bg-arch-dark dark:bg-white text-white dark:text-arch-dark px-6 py-3 text-xs font-bold uppercase tracking-widest hover:bg-brand-500 dark:hover:bg-brand-500 hover:text-white dark:hover:text-white transition-colors duration-300">
                <span>Poptávka</span>
                <SafeIcon icon={FiArrowRight} className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </nav>

          {/* Mobile Menu Buttons */}
          <div className="md:hidden flex items-center space-x-4">
            <button 
              onClick={toggleTheme}
              className="p-2 text-arch-dark dark:text-white hover:text-brand-500 transition-colors"
            >
              <SafeIcon icon={isDark ? FiSun : FiMoon} className="w-5 h-5" />
            </button>
            <button 
              onClick={toggleMenu}
              className="p-2 text-arch-dark dark:text-white hover:text-brand-500 transition-colors"
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div 
              className="md:hidden border-t border-arch-border dark:border-dark-border bg-white dark:bg-dark-bg"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
            >
              <div className="flex flex-col py-6 space-y-6 px-4">
                <Link to="/features" onClick={toggleMenu} className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-widest hover:text-accent-teal">Vlastnosti</Link>
                <Link to="/products" onClick={toggleMenu} className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-widest hover:text-accent-sage">Produkty</Link>
                <Link to="/materials" onClick={toggleMenu} className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-widest hover:text-brand-500">Materiály</Link>
                <Link to="/specifications" onClick={toggleMenu} className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-widest hover:text-accent-clay">Specifikace</Link>
                <Link to="/downloads" onClick={toggleMenu} className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-widest hover:text-brand-500">Stažení</Link>
                <a href="/#contact" onClick={toggleMenu} className="bg-brand-500 text-white px-6 py-3 text-sm font-bold uppercase tracking-widest text-center">
                  Získat nabídku
                </a>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

export default Header;